var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1956_3776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 16H34V12C34 6.48 29.52 2 24 2C18.48 2 14 6.48 14 12V16H12C9.8 16 8 17.8 8 20V40C8 42.2 9.8 44 12 44H36C38.2 44 40 42.2 40 40V20C40 17.8 38.2 16 36 16ZM24 34C21.8 34 20 32.2 20 30C20 27.8 21.8 26 24 26C26.2 26 28 27.8 28 30C28 32.2 26.2 34 24 34ZM30.2 16H17.8V12C17.8 8.58 20.58 5.8 24 5.8C27.42 5.8 30.2 8.58 30.2 12V16Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1956_3776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
};
export default SvgLock;